import React,{Component} from 'react'
import axios from 'axios/index'
import { APIURL } from '../../../config/config'

class CarLeasingFormPercent extends Component{
  constructor (props){
    super(props)
    this.state = {
      lists: [],
      car_id : this.props.car.car_id,
      // leasingName: ['SCB', 'GE', 'TA', 'KK', 'TIS'],
      // leasingName: ['AYCAL', 'TBANK', 'TISCO', 'CIMB', 'SCB'],
      leasingName: [],
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.loadCarLeasingForm = this.loadCarLeasingForm.bind(this);
    this.loadCarLeasing = this.loadCarLeasing.bind(this);
  }

  componentDidMount() {
    this.loadCarLeasingForm();
    this.loadCarLeasing();
  }

  loadCarLeasingForm() {
    var url = APIURL + '/leasing_setting/';
    axios.get(url)
      .then(res => {
        this.setState({leasingName: res.data})
      });
  }

  loadCarLeasing() {
    var uri =  APIURL + '/car_leasing/'+this.state.car_id;
    axios.get(uri)
      .then(res => {
        // console.log('res.data.length: ', res.data.length)
        // console.log('res.data: ', res.data)
        if(res.data.length===0){
          this.setState({lists: res.data, action: 'add'})
        }else{
          this.setState({lists: res.data, action: 'edit'})
        }

      }).catch(error => {
      this.setState({lists: []})
    })
  }

  handleChangeInput(event) {
    var targetName = event.target.name;
    var value = event.target.value;
    var leasingNameUpdate =  this.state.leasingName
    var leasingNew = []

    var name_median = leasingNameUpdate.filter(leasing => leasing.name_median === targetName)
      .map(
        leasing => leasing.name_median === targetName ? {...leasing, value_median: value} : leasing
      )

    var name_credit = leasingNameUpdate.filter(leasing => leasing.name_credit === targetName)
      .map(
        leasing => leasing.name_credit === targetName ? {...leasing, value_credit: value} : leasing
      )

    var name_no_credit = leasingNameUpdate.filter(leasing => leasing.name_no_credit === targetName)
      .map(
        leasing => leasing.name_no_credit === targetName ? {...leasing, value_no_credit: value} : leasing
      )

    if(name_median.length > 0) {
      leasingNew =  leasingNameUpdate.map(
        leasing => leasing.name_median === targetName ? name_median[0] : leasing
      )
    }

    if(name_credit.length > 0) {
      leasingNew =  leasingNameUpdate.map(
        leasing => leasing.name_credit === targetName ? name_credit[0] : leasing
      )
    }

    if(name_no_credit.length > 0) {
      leasingNew =  leasingNameUpdate.map(
        leasing => leasing.name_no_credit === targetName ? name_no_credit[0] : leasing
      )
    }

    this.setState({
      leasingName: leasingNew
    });
  }

  handleChange(event) {
    event.preventDefault();

    var targetName = event.target.name;
    var value = event.target.value;
    var listsUpdate =  this.state.lists
    var listsUpdateNew = []
    var leasingNameUpdate =  this.state.leasingName

    var name_median = leasingNameUpdate.filter(leasing => leasing.name_median === targetName)
      .map(
        leasing => leasing.name_median === targetName ? {...leasing, value_median: value} : leasing
      )

    var name_credit = leasingNameUpdate.filter(leasing => leasing.name_credit === targetName)
      .map(
        leasing => leasing.name_credit === targetName ? {...leasing, value_credit: value} : leasing
      )

    var name_no_credit = leasingNameUpdate.filter(leasing => leasing.name_no_credit === targetName)
      .map(
        leasing => leasing.name_no_credit === targetName ? {...leasing, value_no_credit: value} : leasing
      )

    if(name_median.length > 0) {
      listsUpdateNew =  listsUpdate.map(
        leasing => leasing.car_leasing_name+'M' === targetName ? {...leasing,car_leasing_price_median: value } : leasing
      )
    }

    if(name_credit.length > 0) {
      listsUpdateNew =  listsUpdate.map(
        leasing => leasing.car_leasing_name === targetName ? {...leasing,car_leasing_price: value } : leasing
      )
    }

    if(name_no_credit.length > 0) {
      listsUpdateNew =  listsUpdate.map(
        leasing => leasing.car_leasing_name+'2' === targetName ? {...leasing,car_leasing_price_nc: value } : leasing
      )
    }

    this.setState({
      lists: listsUpdateNew
    });

  }

  render() {
    var trLeasing = ''
    if(this.state.lists.length === 0){
      trLeasing = this.state.leasingName.map((leasing, index) => {
        var inputM = '';

        inputM = (
          <input
            className="form-control"
            type="number"
            id={leasing.name_median}
            name={leasing.name_median}
            onChange={this.handleChangeInput}
          />
        )

         return (
           <tr key={index}>
             <td style={{width: 100}}>{leasing.name_credit}</td>
             <td style={{width: 150}}>
               {inputM}
             </td>
           </tr>
         )
      })
    }else{

      trLeasing = this.state.lists.map((leasing, index) => {
        var name_credit = leasing.car_leasing_name
        var name_median = leasing.car_leasing_name+'M'
        // var car_leasing_price_median = leasing.car_leasing_price_median === undefined ? '' : leasing.car_leasing_price_median
        // console.log('car_leasing_price_median: ', typeof car_leasing_price_median, car_leasing_price_median)
        var inputM = '';

        inputM = (
          <input
            className="form-control"
            type="number"
            name={name_median}
            value={leasing.car_leasing_price_median || 0}
            onChange={this.handleChange}
          />
        )

        return (
          <tr key={index}>
            <td style={{width: 100}}>{name_credit}</td>
            <td style={{width: 250}}>
              {inputM}
            </td>
          </tr>
        )
      })
    }

    return (
      <div className="card card-accent-primary">
        <form action="" method="post" onSubmit={(event) => this.state.action==='add' ? this.props.onSubmit(event, this.state.leasingName) : this.props.onSubmit(event, this.state.lists) }>
          <div className="card-header">
            <strong>
              {this.state.action==='add'? " บันทึก" : " แก้ไข" }
              ยอดจัด
            </strong>
          </div>
          <div className="card-block">
            <div className="row text-center">
              <table className="tableWhitesmoke" style={{marginTop: 8}}>
                <thead>
                  <tr>
                    <th className="text-center" >ลิสซิ่ง</th>
                    <th className="text-center" >ราคากลาง</th>
                    <th className="text-center hidden" >เครดิต</th>
                    <th className="text-center hidden" >ไม่เครดิต</th>
                  </tr>
                </thead>
                <tbody>
                {trLeasing}
                </tbody>
              </table>
            </div>
          </div>
          <div className="card-footer text-right">
            <button type="reset"
                    onClick={this.props.onHandle.cancel}
                    className="btn btn-sm btn-danger">
              <i className="fa fa-refresh"></i> ยกเลิก
            </button>

            <button type="submit" className={this.state.action==='add'? "btn btn-sm btn-primary" : "btn btn-sm btn-warning" }>
              <i className="fa fa-save"></i>
               {this.state.action==='add'? " บันทึก" : " แก้ไข" }
            </button>
            <input type="hidden" name="action" defaultValue={this.state.action}  />
          </div>
        </form>
      </div>
    )
  }
}

export default CarLeasingFormPercent
